export default __webpack_public_path__ + "static/media/smallCloud.cc00fa46.svg";